import authApi from "@/lib/auth-api.client";
import { supabase } from "@/lib/supabase";
import type { ImpersonationState } from "./types";

// Stable empty-object reference so useMemo dependencies stay stable when
// user_metadata is missing (avoids creating a new {} literal per render).
export const EMPTY_METADATA: Record<string, unknown> = Object.freeze({});

// Safely reads impersonation payload from localStorage. Bad JSON is logged
// and treated as "no impersonation" instead of crashing the provider.
export const readImpersonation = (): ImpersonationState => {
  if (typeof window === "undefined") {
    return { userId: null, metadata: null };
  }
  const userId = localStorage.getItem("impersonate_user_id");
  const metadataRaw = localStorage.getItem("impersonate_metadata");
  let metadata: Record<string, unknown> | null = null;
  if (metadataRaw) {
    try {
      metadata = JSON.parse(metadataRaw) as Record<string, unknown>;
    } catch (parseError) {
      // Invalid JSON - continue with null
    }
  }
  return { userId: userId || null, metadata };
};

export const isMobileDevice = () => {
  if (typeof navigator === "undefined") {
    return false;
  }
  return /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent,
  );
};

// Signs the user out (backend + Supabase local session) and then hard-navigates
// to the given URL. Used for guardrails like mobile-only redirects that must
// invalidate the session before leaving.
export const redirectWithSignOut = async (url: string) => {
  try {
    await authApi.post("/auth/signout");
    await supabase.auth.signOut();
  } catch (error) {
    // Silent fail
  } finally {
    window.location.href = url;
  }
};
